// src/abstract.ts
import { Fn, Option } from "@cometjs/core";
function mapAbstractType(abstract, rangeMap) {
  if (!abstract.__typename) {
    throw new Error("The given object doesn't have __typename");
  }
  const range = rangeMap[abstract.__typename];
  return Fn.range(range, abstract);
}
var mapUnion = mapAbstractType;
var mapInterface = mapAbstractType;
function mapAbstractTypeWithDefault(abstract, rangeMap) {
  if (!abstract.__typename) {
    throw new Error("The given object doesn't have __typename");
  }
  const range = rangeMap[abstract.__typename];
  const defaultRange = rangeMap["_"];
  return range ? Fn.range(range, abstract) : Fn.range(defaultRange, abstract);
}
var mapUnionWithDefault = mapAbstractTypeWithDefault;
var mapInterfaceWithDefault = mapAbstractTypeWithDefault;
function mapOptionalAbstractType(abstract, rangeMap) {
  return Option.map(abstract, abstract2 => mapAbstractType(abstract2, rangeMap));
}
var mapOptionalUnion = mapOptionalAbstractType;
var mapOptionalInterface = mapOptionalAbstractType;
function mapOptionalAbstractTypeWithDefault(abstract, rangeMap) {
  return Option.map(abstract, abstract2 => mapAbstractTypeWithDefault(abstract2, rangeMap));
}
var mapOptionalUnionWithDefault = mapOptionalAbstractTypeWithDefault;
var mapOptionalInterfaceWithDefault = mapOptionalAbstractTypeWithDefault;
export { mapAbstractType, mapAbstractTypeWithDefault, mapInterface, mapInterfaceWithDefault, mapOptionalAbstractType, mapOptionalAbstractTypeWithDefault, mapOptionalInterface, mapOptionalInterfaceWithDefault, mapOptionalUnion, mapOptionalUnionWithDefault, mapUnion, mapUnionWithDefault };